import { render, staticRenderFns } from "./EarningDetail.vue?vue&type=template&id=96840b02&scoped=true"
import script from "./EarningDetail.vue?vue&type=script&lang=js"
export * from "./EarningDetail.vue?vue&type=script&lang=js"
import style0 from "./EarningDetail.vue?vue&type=style&index=0&id=96840b02&prod&scoped=true&lang=css"
import style1 from "./EarningDetail.vue?vue&type=style&index=1&id=96840b02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96840b02",
  null
  
)

export default component.exports